import { CheckCircle2 } from "lucide-react";
import { getNamespaceTranslations } from "../lib/questionnaire-translations";
import { Header } from "./Header";
import { ProgressBar } from "./ui/ProgressBar";
import type { ProgressSectionId } from "../lib/progress-calculator";

interface QuestionnaireSummaryScreenProps {
  onContinue: () => void;
  onBack?: () => void;
  onClose?: () => void;
  language?: "en" | "es";
  logoUrl?: string;
  logoUrlAlt?: string;
  currentStep?: number;
  totalSteps?: number;
  sectionIndex?: number;
  totalSections?: number;
  sectionId?: ProgressSectionId;
}

export function QuestionnaireSummaryScreen({
  onContinue,
  onBack,
  onClose,
  language = "en",
  logoUrl,
  logoUrlAlt,
  currentStep,
  totalSteps,
  sectionIndex,
  totalSections,
  sectionId,
}: QuestionnaireSummaryScreenProps) {
  const t = getNamespaceTranslations(language, "questionnaireSummary");

  return (
    <div className="w-full min-h-screen flex flex-col bg-gradient-to-b from-[#FAFAFA] to-[#E8F0F3]">
      <Header logoUrl={logoUrl} logoAlt={logoUrlAlt} onBack={onBack} onClose={onClose} />

      <main className="flex-1 w-full flex items-start justify-center py-[30px] px-5 lg:px-4 overflow-y-auto">
        <div className="w-full max-w-[640px]">
          {currentStep !== undefined &&
            totalSteps !== undefined &&
            sectionIndex !== undefined &&
            totalSections !== undefined &&
            sectionId !== undefined && (
            <ProgressBar
              currentStep={currentStep}
              totalSteps={totalSteps}
              sectionIndex={sectionIndex}
              totalSections={totalSections}
              sectionId={sectionId}
              language={language}
            />
          )}
          <div className="bg-white border border-gray-200 rounded-2xl p-6 sm:p-8 text-center mt-8">
            <div className="flex gap-4 flex-row items-center">
              <CheckCircle2 className="w-7 h-7 text-[#2E9B4F] mb-4" aria-hidden="true" />

              <h1
                className="text-[24px] sm:!text-[30px] leading-[30px] sm:!leading-[36px] font-normal mb-4"
                style={{ fontFamily: "TT Commons Pro" }}
              >
                {t?.title}
              </h1>
            </div>

            <p
              className="text-base leading-[22px] text-gray-700 mb-6"
              style={{ fontFamily: "TT Commons Pro" }}
              dangerouslySetInnerHTML={{ __html: t?.description || "" }}
            />

            <button
              type="button"
              onClick={onContinue}
              className="w-full h-[50px] inline-flex items-center justify-center rounded-full bg-[#2D55FB] text-white px-[30px] text-lg leading-6 font-medium transition-colors hover:bg-[#2347E8]"
              style={{ fontFamily: "TT Commons Pro" }}
              data-testid="questionnaire_summary-continue_button"
            >
              {t?.continue}
            </button>
          </div>
        </div>
      </main>
    </div>
  );
}
